import { useMemo } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { privateRoutes } from '../routes/privateRoutes';

export const useBreadcrumbs = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const queryString = searchParams.toString() ? `?${searchParams.toString()}` : '';
  
  return useMemo(() => {
    const breadcrumbs = [];
    let currentPath = '';
    let breadcrumb = ''

    location.pathname.split('/')
      .filter(Boolean)
      .forEach((part, i, pathArray) => {
        currentPath += `/${part}`;
        breadcrumb = part.replace(/-/g, "_")
        const match = privateRoutes.find(route => route.path.includes(part));

        if (match) {
          const pathWithParams = i !== 0 && i < pathArray.length - 1 ? currentPath + queryString : currentPath;
          breadcrumbs.push({
            path: pathWithParams,
            breadcrumb: breadcrumb,
          });
        }
      });

    return breadcrumbs;
  }, [location.pathname]);
};